





























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EventModel } from "@/models/event";

@Component({})
export class Physiotherapy extends Vue {
  @Prop({ required: true })
  event!: EventModel;

  @Prop()
  disabled!: boolean;

  get formConfig() {
    return {
      meta: {
        hjhsTotal: {
          label: this.$t("event.fields.hjhsTotal"),
          disabled: this.disabled,
        },
        physiotherapist: {
          label: this.$t("event.fields.physiotherapist"),
          disabled: this.disabled,
        },
        physiotherapistComment: {
          label: this.$t("event.fields.physiotherapistComment"),
          disabled: this.disabled,
        }
      }
    };
  }
}
export default Physiotherapy;
